import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const PersonShieldIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc>person with a shield</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M99.4 150.8a52.4 52.4 0 1 1 52.3-52.3 52.4 52.4 0 0 1-52.3 52.3Zm0-101.7a49.4 49.4 0 1 0 49.3 49.4A49.4 49.4 0 0 0 99.4 49Z"
        className="accent"
      />
      <path
        d="M100.5 41.8a7.9 7.9 0 1 1-8 7.9 7.9 7.9 0 0 1 8-8Z"
        className="accent"
        fillRule="evenodd"
      />
      <path
        d="M99.7 65.9a62.3 62.3 0 0 0-8 .5 54.3 54.3 0 0 0-5.8 1V83a10.7 10.7 0 0 0 2.1 6 23.9 23.9 0 0 0 5 5 42.9 42.9 0 0 0 6.7 4.2Z"
        className="accent"
      />
      <path
        d="M99.7 63.7a52.4 52.4 0 0 0-14.7 2v17.1c0 10.5 14.7 17.6 14.7 17.6s14.6-7.1 14.6-17.6v-17a52.3 52.3 0 0 0-14.6-2ZM112 83a11 11 0 0 1-2 6 22.2 22.2 0 0 1-4.4 4.8 37.2 37.2 0 0 1-6 4.1 37.7 37.7 0 0 1-6-4 22.5 22.5 0 0 1-4.4-5 11 11 0 0 1-2-6v-15a44.4 44.4 0 0 1 5.4-1 51.3 51.3 0 0 1 14.1 0 44.4 44.4 0 0 1 5.3 1ZM80.1 65.8l-27-10.5a4.5 4.5 0 1 0-3.1 8.4l30.1 11.6Zm38.5-.4L145.5 55a4.5 4.5 0 1 1 3.2 8.3L118.6 75Z"
        className="accent"
      />
      <path
        d="m100.4 107.2-.4.2-.4-.2a45.3 45.3 0 0 1-12.3-7.9v15.2h25V99.7a45.7 45.7 0 0 1-12 7.5Z"
        className="accent"
      />
      <rect
        x="109.3"
        y="110"
        width="8.9"
        height="45.5"
        rx="4.5"
        transform="rotate(162.8 113.7 132.8)"
        className="accent"
      />
      <rect
        x="81.8"
        y="110"
        width="8.9"
        height="45.5"
        rx="4.5"
        transform="rotate(17.2 86.2 132.8)"
        className="accent"
      />
      <path d="M93 121.2s7-13.4 13.7-.4l2.9-8.6-20.4-.6Z" className="accent" />
    </Icon>
  );
};

export default PersonShieldIcon;
